"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
var _Menu = _interopRequireDefault(require("./Menu"));
exports.default = _Menu.default;